
<span
  class="badge"
  :class="{
    'badge-primary': status === statusType.Planned,
    'badge-secondary': status === statusType.Shared,
    'badge-warning': status === statusType.InProgress,
    'badge-success': status === statusType.Done || status === statusType.UnderReview,
    'badge-info': status === statusType.Information,
    'bi-badge': size === 'xl',
    'badge-pill': size !== 'xl',
  }"
  :style="styles"
>
  {{ status }}
</span>
